import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import Home1 from "../../assets/images/home_header.png";
import Home2 from "../../assets/images/home_whychooseus.png";
import Home3 from "../../assets/images/home_meetashley.png";
import { ReactComponent as ClearAdvice } from "../../assets/icons/clear_advice.svg";
import { ReactComponent as PersonalService } from "../../assets/icons/personal_service.svg";
import { ReactComponent as FullSupport } from "../../assets/icons/full_support.svg";
import { ReactComponent as FirstTimeBuyerIcon } from "../../assets/icons/firsttime_buyer.svg";
import { ReactComponent as RemortgagingIcon } from "../../assets/icons/remortgages.svg";
import { ReactComponent as HomeMoversIcon } from "../../assets/icons/home_movers.svg";
import { ReactComponent as BuyToLetIcon } from "../../assets/icons/buy_to_let.svg";
import { ReactComponent as ProductTransferIcon } from "../../assets/icons/product_transfer.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/protection_insurance.svg";

const LandingPage = () => {
  return (
    <div>
      <SEO
        title="AK Mortgage Solutions Ltd"
        description="Friendly, honest and ethical mortgage and protection advice for first-time buyers, home movers, remortgages and buy-to-let clients across the UK."
        path="/"
      />
      {/* <Hero
        title={`Financial Clarity
Direction & Confidence`}
        subtitle="Wealth Management Solutions"
        titleAlign="left"
        subtitleAlign="left"
      >
        <div className="hero-column">
          <div className="content">
            At FG Wealth Advisory, we provide clear, personalised financial
            advice to help you grow, protect and maximise your wealth. By
            understanding your goals, we deliver tailored support across
            pensions, investments and insurance for individuals, families and
            business owners, with a focus on long-term relationships that bring
            confidence, clarity and control over your financial future.
          </div>

        
        </div>
      </Hero>
      <div className="page-container">
        <PrimaryButton text="Primary Button" />
        <PrimaryButtonSmall text="Primary Button Small" />
        <SecondaryButton text="Secondary Button" />
        <SecondaryButtonSmall text="Secondary Button Small" />
        <TextButton text="Text Button" />
        <SeeMoreButton text="See More" />
        <TertiaryButton text="Tertiary Button" />
        <Accordion
          title="Accordion Title"
          children={
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          }
        />
      </div> */}
      <div className="background-container bg-gray-3">
        <div className="content-container row-center grid2 gap-xxxxxl row-center">
          <img src={Home1} alt="AK Mortgages adviser welcoming a client" className="hero-image" />
          <div className="column gap-m">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              Friendly. Honest. Ethical.
            </div>
            <h2 className="text-primary-1 uppercase">
              Mortgages Made Simple, Honest Advice You Can Trust
            </h2>
            <div className="content text-primary-1">
              Whether you're buying your first home, remortgaging, investing in
              property, or protecting what matters most, AK Mortgages provides
              straightforward mortgage and protection advice tailored to your
              needs.
            </div>
            <PrimaryButton text="Contact Us" />
          </div>
        </div>
      </div>
      <div className="background-container bg-primary-1">
        <div className="content-container row gap-xxxxxl">
          <div className="column-center  gap-xl">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              <ClearAdvice className="hero-image" />
            </div>
            <div className="gap-m column-center">
              <div className="subtitle-semibold  text-white uppercase">
                Clear Advice
              </div>
              <div className="content text-white ">
                Honest, transparent guidance without jargon so you always
                understand your options.
              </div>
            </div>
          </div>
          <div className=" column-center  gap-xl">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              <PersonalService className="hero-image" />
            </div>
            <div className="gap-m column-center">
              <div className="subtitle-semibold  text-white uppercase">
                Personal Service
              </div>
              <div className="content text-white ">
                Friendly, tailored recommendations based on your individual
                circumstances.
              </div>
            </div>
          </div>
          <div className=" column-center  gap-xl">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              <FullSupport className="hero-image" />
            </div>
            <div className="gap-m column-center">
              <div className="subtitle-semibold  text-white uppercase">
                Full Support
              </div>
              <div className="content text-white ">
                Help and guidance from your initial application right through to
                final completion process.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container">
        <div className="content-container row-reverse gap-xxxxxl row-reverse">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              why choose us
            </div>
            <h3 className="text-primary-1 uppercase">
              Mortgages Made Simple, Honest Advice You Can Trust
            </h3>
            <div className="column gap-s">
              <div className="content text-primary-1">
                At AK Mortgages, we believe mortgage and protection advice
                should be clear, honest and stress-free. We take the time to
                understand your circumstances, explain your options, and help
                you secure the right solution for your future.
                {/* <br/> */}
              </div>
              <div className="content text-primary-1">
                Whether you're a first-time buyer taking your first step onto
                the property ladder or an experienced landlord expanding your
                portfolio, we're here to guide you every step of the way.
              </div>
            </div>
            <PrimaryButton text="Contact Us" />
          </div>
          <img src={Home2} alt="Mortgage advice consultation" className="hero-image" />
        </div>
      </div>
      <div className="background-container bg-gray-3">
        <div className="content-container column-center gap-xxxl">
          <div className="row gap-xxxxxl row-start">
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                <FirstTimeBuyerIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  First-time buyer
                </div>
                <div className="content text-primary-1">
                  Designed for people buying their first home, often with lower
                  deposit options and extra support.
                </div>
              </div>
            </div>
            <div className=" column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-1 uppercase">
                <RemortgagingIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  Remortgaging
                </div>
                <div className="content text-primary-1">
                  Switch your existing mortgage to a new deal, usually to get a
                  better rate or release equity.
                </div>
              </div>
            </div>
            <div className="column-center  gap-xl">
              <div className="subtitle-semibold  text-primary-1 uppercase">
                <ProtectionIcon className="hero-image" />
              </div>
              <div className="gap-m column-center">
                <div className="subtitle-semibold  text-primary-1 uppercase">
                  Protection & Insurance
                </div>
                <div className="content text-primary-1">
                  Covers options like life insurance and critical illness cover
                  to protect you and your home.
                </div>
              </div>
            </div>
          </div>
          <div className="body2 text-primary-1">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
      <div className="background-container">
        <div className="content-container row gap-xxxxxl">
          <img src={Home3} alt="Ashley Knight from AK Mortgages" className="hero-image" />
          <div className="column gap-m">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              About Us
            </div>
            <h3 className="text-primary-1 uppercase">Meet ashley Knight</h3>
            <div className="column gap-s">
              <div className="content text-primary-1">
                I'm Ashley Knight, founder of AK Mortgages and a dedicated
                Mortgage & Protection Adviser based in Bristol. I started AK
                Mortgages with a simple goal: to provide honest, ethical advice
                that genuinely helps people make confident financial decisions.
                I understand that every client is different, which is why I take
                the time to understand your circumstances and explain your
                options clearly.
              </div>
              <div className="content text-primary-1">
                Whether you're buying your first home, remortgaging, investing
                in property or arranging protection for your family, I'll be
                with you throughout the entire process.
              </div>
            </div>
            <PrimaryButton text="Contact Us" />
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1">
        <div className="content-container column gap-l">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-white uppercase">
              Ready to discuss your mortgage?
            </div>

            <div className="content text-white">
              Whether you're buying your first home, looking for a better
              mortgage deal, or arranging protection for your family, we're here
              to help.
            </div>
            <div className="content text-white">
              Book a free, no-obligation consultation with one of our advisers
              at AK Mortgages.
            </div>
            <PrimaryButton
              text="book a free initial appointment"
              onClick={() =>
                window.open(
                  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled",
                  "_blank",
                )
              }
            />
          </div>
          <div className="body2 text-white">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
